<ng-container *ngIf="{total: total$ | async, query: query$ | async,title: title$ | async} as observables">
  <div class="d-flex flex-column flex-sm-row"
       data-cy="search-results-title"
       *ngIf="observables.total !== undefined; else showLoading">
    <div class="d-flex">
      <span class="search-results-title body--s text-nowrap me-1">{{observables.title}}</span>
    </div>
    <span *ngIf="observables.query" class="search-results-title__query me-4 body--s"
    >"{{observables.query}}"</span>
  </div>
  <ng-template #showLoading>
    <div class="d-flex align-content-center">
      <dcp-loading-indicator/>
    </div>
  </ng-template>
</ng-container>
